import * as React from "react";
import {useState} from "react";
import {TextField, Snackbar, Otp, Button, Loading} from "web-com";
import {imageBaseUrl} from "config";
import {INPUT_TYPE, StyleType} from "utils/variables";
import {FIELD_NAMES} from "profile/enums";
import {doSignin, verifyOtp} from "login/TwoFactorLogin/api";
import {setAuthentication} from "service";
import {setAuthParameters, setTwoFactorAuth} from "login/actions";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import "./styles.scss";

enum LENGTH {
  OTP = 6,
  MOBILE = 10,
};
interface IConnectProps {
  dispatch?: (action: any) => void;
  query: any;
}

const LoginV3 = ({dispatch, query}: {dispatch: (action: any) => void, query: any}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState<Date>()
  const [error, setError] = useState<string>();
  const [otp, updateOtp] = useState<string[]>();
  const [mobileNumber, updateMobileNumber] = useState<string>();
  const [renderOtpField, setRenderOtpField] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const generateOtp = async () => {
    setIsLoading(true);
    try {
      await doSignin(null, +mobileNumber, date.toString());
      setIsButtonEnabled(false);
      setRenderOtpField(true);
    } catch (error) {
      setError(error.response?.data?.message  || "Something went wrong!");
    } finally {
      setIsLoading(false)
    }
  }

  const verifyAndSignIn = async () => {
    if (otp.length !== LENGTH.OTP) return;
    setIsLoading(true)
    try {
      const res = await verifyOtp({dob: date.toString(), mobile: +mobileNumber, otp: +otp.join("")});
      if (res.data.token) {
        setAuthentication(res.data.token);
        dispatch(setAuthParameters({...query, accessToken: res.data.token, userId: res.data.userId}));
        dispatch(setTwoFactorAuth({"existing": true, "roles": res.data.roles, "userId": res.data.userId}));
      }
    } catch (error) {
      setError(error.response?.data?.message  || "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-form-container container-fluid">
      <Loading active={isLoading} />
      <div className="row justify-content-center">
        <div className="card col-11 login-form-card">
          <div className="card-body">
            <Snackbar
              type="danger"
              show={!!error}
              onCloseHandler={() => setError(undefined)}
              timeout={5000}
            >
              {error}
            </Snackbar>
            <div className="logo-wrapper">
              <img className="logo" src={`${imageBaseUrl}/img/logo/sl_new_logo1.png`} alt="Logo" />
            </div>
            <p className="title-text text-center">SignIn to your MyShubhLife account</p>
            <div>
            <TextField
              type={INPUT_TYPE.DATE}
              label={"Date Of Birth"}
              value={date || ""}
              fieldName={FIELD_NAMES.MOBILE}
              onChange={(type, value) => setDate(value)}
              styleType={StyleType.ROUNDED_INPUT}
            />
            <TextField
              type={INPUT_TYPE.NUMBER}
              label={"Mobile Number"}
              placeholder={"Enter mobile number"}
              value={mobileNumber || ""}
              fieldName={FIELD_NAMES.MOBILE}
              onChange={(type, value) => {if (value.length === LENGTH.MOBILE) setIsButtonEnabled(true); updateMobileNumber(value)}}
              disabled={!!renderOtpField}
              styleType={StyleType.ROUNDED_INPUT}
            />
            {renderOtpField && 
              <Otp
                otp={otp || []}
                otpLength={LENGTH.OTP}
                otpType={INPUT_TYPE.NUMBER}
                updateOtp={(newOtp) => {if (newOtp.length === LENGTH.OTP) setIsButtonEnabled(true); updateOtp([...newOtp])}}
                resendOtp={generateOtp}
              />}
              <Button
                buttonText={renderOtpField ? "Sign in" : "Generate OTP"}
                onClick={() => renderOtpField ? verifyAndSignIn() : generateOtp()}
                isDisabled={!isButtonEnabled}
                width={200}
                fontWeight={500}
                height={45}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const query = state.router.location.query ? state.router.location.query : null;
  return {
    query,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoginV3);
